import { render } from "./BottomNavigationNoAuthComponent.vue?vue&type=template&id=31fc113f&scoped=true"
import script from "./BottomNavigationNoAuthComponent.vue?vue&type=script&lang=js"
export * from "./BottomNavigationNoAuthComponent.vue?vue&type=script&lang=js"

import "./BottomNavigationNoAuthComponent.vue?vue&type=style&index=0&id=31fc113f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31fc113f"]])

export default __exports__